import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import styled from 'styled-components'
import UnacceptedStockAwards from './UnacceptedStockAwards'
import VestingSummary from './VestingSummary'
import PopularActions from './PopularActions'
import HelpfulInformation from '../HelpfulInformation'
import Faqs from '../Faqs'
import { connect } from "react-redux";
import siteContentService from '../../../services/SiteContent.service'
import employeeService from '../../../services/Employee.service'

const Container = styled.div`
  background-color: white;
`

class Dashboard extends Component {

  componentDidMount(){
    document.title = this.props.t('Header.Title') + " " + this.props.t('Navigation.StockAwardLabel')
    document.getElementById('main-h1').innerHTML = this.props.t('Header.Title') + " " + this.props.t('Navigation.AtAGlanceLabel')
  }

  render() {
    const { employee } = this.props;
    const has_awards = employee.awards.length > 0

    return (
      <Container id="dashboard">
        {has_awards &&
          <UnacceptedStockAwards />
        }
        {has_awards &&
          <VestingSummary />
        }

        <PopularActions fractional_mode={this.props.fractional_mode} employee={this.props.employee} />

        {!employeeService.isWholeFoodsEmployee(employee) &&
          <HelpfulInformation articles={this.props.articles} />
        }
        {!employeeService.isWholeFoodsEmployee(employee) &&
          <Faqs faqs={this.props.faqs} />
        }
      </Container>
    )
  }
}

const mapState = state => ({
  articles: siteContentService.getHomepageArticles(state.static_content, employeeService.isZooxEmployee(state.employee)),
  faqs: siteContentService.getFaqs(state.static_content),
  fractional_mode: state.static_content.fractional_mode,
  employee: state.employee,
});

export default connect(mapState)(withTranslation("translations")(Dashboard));

